import React, { useCallback, useState } from "react";


interface Props {
    title?: string
    children: any;
    width?: number;
    customClass?: string;
    rightComponent?: any;
    onClick?: any;
}


export default function ViewBox(props: Props) {
    return (

        <div onClick={props.onClick} className={props.customClass !== undefined ? props.customClass : 'viewBox'} style={{ justifySelf: "center", alignSelf: "center", width: props.width !== undefined ? props.width + '%' : undefined }}>
            <div className="boxHeader">
                {props.title !== undefined && (
                    <div style={{ display: "flex", justifyContent: "space-between", width: '100%', color: '#000', }}>
                        <div className="viewBoxTitle">{props.title}</div>
                        {props.rightComponent && (
                            props.rightComponent
                        )}
                    </div>

                )}
            </div>
            {props.children}
        </div>

    )

}
